import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { gettingCurrencyNumberWithOutSymbol } from "../../helpers/get-currency-number";
import { TRootState } from "../../store";
import { useEffect } from "react";
import { setCalenderDate } from "../../reducers/reports_slice";
import TableView from "../../components/table_new";

const RevenueReport = () => {

  const { revenueReportFilter, isLoading, selectedReportStatusFilter } =
    useSelector((state: TRootState) => ({
      revenueReportFilter: state.reports.revenueReportFilter,
      isLoading: state.reports.isLoading,
      selectedReportStatusFilter: state.trades.selectedReportStatusFilter
    }));

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setCalenderDate({
        fromDate: moment().startOf("month").format("YYYY-MM-DD"),
        toDate: moment().endOf("month").format("YYYY-MM-DD"),
        mode: "MONTHLY",
      })
    );
  }, []);

  const type = selectedReportStatusFilter.includes('REVENUE') ? 'OPEN' : 'CLOSED'

  return (
    <>
      <div className="card_space_18">
        <TableView
          height="calc(100vh - 14rem)"
          loading={isLoading}
          columns={[
            {
              key: "sNo",
              header: "#",
              className: "min-w-[50px] text-center sticky left-0",
            },
            {
              key: "id",
              header: "ID",
              className: "min-w-[8%] sticky left-[50px]",
            },
            {
              key: "finPartnerName",
              header: "Finance Partner",
              className: "min-w-[18%]",
            },
            {
              key: "source",
              header: "Source",
              className: "min-w-[8%]",
            },
            {
              key: "closedDate",
              header: "Date",
              className: "min-w-[10%]",
            },
            {
              key: "grossRev",
              header: "Gross Revenue (₹)",
              className: "min-w-[10%]",
              type: "NUMBER",
            },
            {
              key: "transportation",
              header: "Transportation (₹)",
              className: "min-w-[10%]",
              type: "NUMBER",
            },
            {
              key: "disbursement",
              header: "Disbursement (₹)",
              className: "min-w-[10%]",
              type: "NUMBER",
            },
            {
              key: "pf",
              header: "Platform Fee (₹)",
              className: "min-w-[10%]",
              type: "NUMBER",
            },
            {
              key: "delayCharges",
              header: "Delay Charges (₹)",
              className: "min-w-[10%]",
              type: "NUMBER",
            },
          ]}
          data={revenueReportFilter?.map((item, i) => {
            return {
              sNo: i + 1,
              id: item?.id,
              finPartnerName: item?.finPartnerName || "-",
              source: item?.source,
              closedDate:
                type === 'OPEN'
                  ? item?.pmtReceiptDate
                    ? moment(item.pmtReceiptDate).format('DD-MMM-YYYY')
                    : '-'
                  : item?.closedDate
                    ? moment(item.closedDate).format('DD-MMM-YYYY')
                    : '-',
              grossRev: gettingCurrencyNumberWithOutSymbol(item.grossRev, true),
              transportation: gettingCurrencyNumberWithOutSymbol(item.transportation, true),
              disbursement: gettingCurrencyNumberWithOutSymbol(item.disbursement, true),
              pf: gettingCurrencyNumberWithOutSymbol(item.pf, true),
              delayCharges: gettingCurrencyNumberWithOutSymbol(item.delayCharges, true),
            };
          })}
        // rowClickAction="expand"
        // isRowExpandable={(row) => true}
        // renderExpandedRow={(row) => <span>hii</span> }
        />
      </div>
    </>
  );
};

export default RevenueReport;
